import React, { useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import "./NewUserScreen.css";
import Copyright from "../../components/Footer/Copyright";
import { auth } from "../../firebase.js";
import GoToTop from '../../GoToTop';
import Reel from "../../assets/mars.webm";
import logo from "../../assets/Redground-oldlogo.png";

function NewUserScreen() {

    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const navigate = useNavigate();

    const register = (e) => {
        e.preventDefault();

        auth
            .createUserWithEmailAndPassword(
                emailRef.current.value,
                passwordRef.current.value
            )
            .then((authUser) => {
                navigate('/mars');
            })
            .catch((error) => {
                alert(error.message);
            });
    }

    const gotoSignin = (e) => {
        e.preventDefault();
        navigate("/");
    }
    

  return (
    <div>
        <header className="newuser__banner" >

            <video autoPlay loop muted
                style={{
                    position: "absolute",
                    zIndex: "-1",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    backgroundPosition: "center center",
                    backgroundImage: `linear-gradient(to top, black 10%, transparent 90%), linear-gradient(to right, #00001b, transparent)`,
                }}>
                <source src={Reel} type='video/webm' />
            </video>

            <div className="newuser__signup">

                <div className="newuser__signup__msg">
                    <p>Welcome to</p>
                    <img
                        src={logo}
                        alt=""
                    />
                </div>

                <form >
                    <input  ref={emailRef} type="email" placeholder="email" id="email" />

                    <input ref={passwordRef} type="Password" placeholder="password" id="password" />

                    <button 
                    type="submit" onClick={register}>
                        Create account
                    </button>
                </form>
                
                <div className="newuser__signup__help">
                <p >Have an account already?</p>
                <span
                    onClick={gotoSignin}
                >Log In Here.</span>
                </div>

            </div>
            
        </header>
        
        <Copyright />
        <GoToTop />
    </div>
  )
}

export default NewUserScreen;